module.exports = __webpack_public_path__ + "a44763910466c01f15f4017a1a735283.svg";